import React, { Component } from 'react';
import { fireAddToCart } from './MetaPixel';
interface HolographicButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  size?: 'md' | 'lg';
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  firePixelEvent?: boolean;
}
export function HolographicButton({
  children,
  href,
  onClick,
  className = '',
  size = 'lg',
  variant = 'primary',
  fullWidth = false,
  firePixelEvent = false
}: HolographicButtonProps) {
  const baseClasses = 'relative inline-flex items-center justify-center font-bold transition-all duration-200 transform active:scale-95 holographic-shimmer rounded-lg shadow-lg hover:shadow-xl';
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-lg md:text-xl' : 'px-6 py-3 text-base';
  const variantClasses = variant === 'primary' ? 'bg-primary text-white hover:bg-primary-dark border border-transparent' : 'bg-white text-primary border-2 border-primary hover:bg-gray-50';
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent) => {
    if (firePixelEvent) {
      fireAddToCart();
    }
    if (onClick) {
      onClick();
    }
  };
  const Component = href ? 'a' : 'button';
  return <Component href={href} onClick={handleClick} className={`${baseClasses} ${sizeClasses} ${variantClasses} ${widthClass} ${className}`} {...href && !href.startsWith('#') ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} data-id="element-102">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-103">
        {children}
      </span>
    </Component>;
}